import React from "react";

export const ADSENSE_CLIENT = "ca-pub-2106493684885233";

export function GoogleAdSlot({
  slot,
  className = "",
  mobileMinHeight = 50,
  desktopMinHeight = 90,
  testId = "google-ad-slot",
}) {
  const requestedRef = React.useRef(false);

  React.useEffect(() => {
    if (requestedRef.current || !slot) return;
    requestedRef.current = true;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {
      requestedRef.current = false;
    }
  }, [slot]);

  return (
    <div
      className={`ol-adsense-slot w-full overflow-hidden bg-white ${className}`}
      style={{
        "--ol-ad-mobile-height": `${mobileMinHeight}px`,
        "--ol-ad-desktop-height": `${desktopMinHeight}px`,
      }}
      data-testid={testId}
      aria-label="Pubblicità"
    >
      <div className="px-3 py-2 text-center text-[11px] sm:text-xs leading-relaxed text-muted bg-cream/60 border-b border-edge">
        Spazio pubblicitario in vendita. Contatta l'amministrazione tramite la voce Segnalazione che trovi nel menu e selezionando Altro come tema della segnalazione da inviare.
      </div>
      <ins
        className="adsbygoogle ol-adsense-unit"
        style={{ display: "block", width: "100%" }}
        data-ad-client={ADSENSE_CLIENT}
        data-ad-slot={slot}
        data-ad-format="horizontal"
        data-full-width-responsive="true"
      />
    </div>
  );
}
